import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import { ScrollContainer } from 'components/shared/DataTable';
import { BodySmallBold } from 'styles/typography';

export const SectionCard = styled(Card)`
  padding: 0;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
`;

export const TableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 24px 24px;

  td:first-child:not(:last-child),
  th:first-child {
    border-right: 1px solid ${({ theme }) => theme.colors.black10};
  }

  @media (max-width: 800px) {
    padding: 0;

    ${ScrollContainer} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-left: none;
      border-right: none;
      border-bottom: none;
    }
  }
`;

export const SectionHeader = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 800px) {
    padding: 16px;
  }
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitle = styled(BodySmallBold)`
  color: ${({ theme }) => theme.colors.black};
`;

export const MobileSubtitle = styled.span`
  color: ${({ theme }) => theme.colors.black50};
  font-size: 10px;
  font-weight: normal;
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
